import React from "react";
import classes from "./SubscriptionPage2.module.css";
import { motion } from "framer-motion";
import LinedSection from "../component/LinedSection";
import { FaArrowRight, FaStar } from "react-icons/fa6";


const SubscriptionPage2 = () => {
    return (
        <main className={classes.main}>

            <motion.div
                className={classes.container}
                initial={{
                    backgroundImage:
                        "radial-gradient(820% 320% at 50% 25%, #000,#e20808)",
                }}
                animate={{
                    backgroundImage: [
                        "radial-gradient(820% 320% at 50% 25%, #000,#e20808)",
                        "radial-gradient(820% 320% at 50% 25%, #000, #0a58b7)",
                        "radial-gradient(820% 320% at 50% 25%, #000, #ff5424)",
                        "radial-gradient(820% 320% at 50% 25%, #000, #0f5cec)",
                    ],
                }}
                transition={{
                    duration: 7,
                    ease: "easeInOut",
                    repeat: Infinity,
                    repeatType: "mirror",
                }}
            >

                {/* subtle glow background */}
                <div className={classes.glowLayer} />

                <LinedSection />

                <section className={classes.shell}>

                    {/* TOP HEADER */}
                    <section className={classes.hero_container}>
                        <header className={classes.topBar}>
                            <div className={classes.brand}>
                                <div className={classes.brand_container}>
                                    <img src="/images/logo2.png" alt="uv gaming" className={classes.uv_logo} />
                                    <div className={classes.brandSub}>Powered by Vodacom</div>
                                </div>
                            </div>

                            <div className={classes.topActions}>
                                <button className={classes.btnGhost}>Entrar</button>
                                <button className={classes.btnPrimary}>Subscrever</button>
                            </div>
                        </header>
                    </section>


                    {/* HERO */}
                    <section className={classes.hero_container}>

                        <div className={classes.red_swoosh_container}>
                            <img src="/images/red-swoosh.png" alt="red swoosh" className={classes.red_swoosh_img} />
                        </div>

                        <section className={classes.hero}>

                            <div className={classes.heroLeft}>
                                <h1 className={classes.heroTitle}>
                                    Jogos Ilimitados <br />
                                    <span>no Teu Telemóvel</span>
                                </h1>

                                <div className={classes.pricePill}>
                                    A partir de <b>3MT</b> / Dia
                                </div>

                                <div className={classes.heroChips}>
                                    <div className={classes.chip}>
                                        <img src="/images/android.png" alt="android" className={classes.android_icon} />
                                        HTML5 + Android</div>
                                    <div className={classes.chip}>
                                        <img src="/images/wallet2.png" alt="wallet" className={classes.android_icon} />
                                        Paga com <b>
                                            Saldo
                                        </b>
                                        ou
                                        <img src="/images/m-pesa.png" alt="m-pesa" className={classes.mpesa_in_chip} />
                                    </div>
                                </div>
                            </div>

                            <div className={classes.heroRight}>
                                <img src="/images/hero-image8.png" alt="Hero" className={classes.heroImage} />
                            </div>


                        </section>
                    </section>


                    {/* PLANS + HOW */}
                    <section className={classes.hero_container}>
                        <section className={classes.midGrid}>


                            <motion.div className={classes.cardSection}
                                initial={{
                                    backgroundImage:
                                        "radial-gradient(820% 320% at 50% 25%, #000,#e20808)",
                                }}
                                animate={{
                                    backgroundImage: [
                                        "radial-gradient(820% 320% at 50% 25%, #000,#e20808)",
                                        "radial-gradient(820% 320% at 50% 25%, #000, #ff0000)",
                                        "radial-gradient(820% 320% at 50% 25%, #000, #20b000)",
                                        "radial-gradient(820% 320% at 50% 25%, #000, #610000)",
                                    ],
                                }}
                                transition={{
                                    duration: 7,
                                    ease: "easeInOut",
                                    repeat: Infinity,
                                    repeatType: "mirror",
                                }}
                            >

                                <div className={classes.cardSectionBg}></div>

                                {/* <Lottie animationData={gridAnimation} loop autoPlay className={classes.animation_grid} /> */}
                                <h4 className={classes.sectionTitle}>Escolhe o Teu Plano</h4>

                                <div className={classes.planGrid}>
                                    <div className={classes.planCard}>
                                        <div className={classes.planName}>Diário</div>
                                        <div className={classes.planPrice}>
                                            <span>3</span>MT
                                        </div>
                                        <div className={classes.planFeature}>
                                            <img src="/images/game-controller.png" alt="game" className={classes.planIcon} />
                                             Acesso 24H</div>
                                        <button className={classes.planBtn}>Subscrever</button>
                                    </div>

                                    <div className={`${classes.planCard} ${classes.popular}`}>
                                        <div className={classes.badge}>Mais Popular</div>
                                        <div className={classes.planName}>Semanal</div>
                                        <div className={classes.planPrice}>
                                            <span>20</span>MT
                                        </div>
                                        <div className={classes.planFeature}>
                                            <img src="/images/schedule.png" alt="game" className={classes.planIcon} />
                                             7 Dias de Jogos</div>
                                        <button className={classes.planBtn}>Subscrever</button>
                                    </div>

                                    <div className={classes.planCard}>
                                        {/* <div className={classes.badgeAlt}>Melhor Valor</div> */}
                                        <div className={classes.planName}>Mensal</div>
                                        <div className={classes.planPrice}>
                                            <span>50</span>MT
                                        </div>
                                        <div className={classes.planFeature}>
                                            <img src="/images/calendar.png" alt="game" className={classes.planIcon} />
                                             30 Dias de Jogos</div>
                                        <button className={classes.planBtn}>Subscrever</button>
                                    </div>
                                </div>

                            </motion.div>

                            <aside className={classes.howCard}>
                                <div className={classes.howTitle}>Como Funciona?</div>

                                <div className={classes.steps}>
                                    <div className={classes.step}>
                                        <div className={classes.stepNum}>1</div>
                                        <div className={classes.stepText}>Escolhe o Plano</div>
                                    </div>
                                    <div className={classes.step}>
                                        <div className={classes.stepNum}>2</div>
                                        <div className={classes.stepText}>Paga (M-Pesa/Saldo)</div>
                                    </div>
                                    <div className={classes.step}>
                                        <div className={classes.stepNum}>3</div>
                                        <div className={classes.stepText}>Começa a Jogar!</div>
                                    </div>
                                </div>

                                <button className={classes.activateBtn}>
                                    Ativar Agora <span className={classes.arrow}><FaArrowRight /></span>
                                </button>
                            </aside>
                        </section>
                    </section>

                    <section className={classes.shell}>

                        {/* FEATURED GAMES */}
                        <section className={classes.hero_container}>
                            <section className={classes.featuredWrap}>
                                <div className={classes.featuredHead}>
                                    <div className={classes.sectionTitleSmall}>Jogos em Destaque</div>
                                    <button className={classes.linkBtn}>Ver Todos</button>
                                </div>

                                <div className={classes.gamesRow}>
                                    <div className={classes.gameCard}>
                                        <img src="../images/feature-bg.png" alt="game" className={classes.gameImage} />
                                        <div className={classes.gameLabel}>
                                            <p className={classes.gameText}>

                                                Car Racing</p></div>
                                    </div>

                                    {/* <div className={`${classes.gameCard} ${classes.gameActive}`}> */}
                                    <div className={`${classes.gameCard}`}>
                                        <img src="../images/feature-bg.png" alt="game" className={classes.gameImage} />
                                        <div className={classes.gameLabel}>
                                            <p className={classes.gameText}>

                                                Battle Arena</p></div>
                                    </div>

                                    <div className={classes.gameCard}>
                                        <img src="../images/feature-bg.png" alt="game" className={classes.gameImage} />
                                        <div className={classes.gameLabel}>
                                            <p className={classes.gameText}>
                                                Futebol Pro
                                            </p>
                                        </div>
                                    </div>

                                    <div className={classes.gameCard}>
                                        <img src="../images/feature-bg.png" alt="game" className={classes.gameImage} />
                                        <div className={classes.gameLabel}>
                                            <p className={classes.gameText}>
                                                Aventura
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </section>


                        {/* PAYMENT + APP */}
                        <section className={classes.hero_container}>
                            <section className={classes.bottomGrid}>
                                <div className={classes.paymentCard}>
                                    <div className={classes.cardTitle}>
                                        <span className={classes.iconDot} /> Pagamento Fácil
                                    </div>

                                    <div className={classes.logoGrid}>
                                        <div className={classes.paymentMethod}>
                                            <img src="/images/vodacom-logo.png" alt="vodacom" className={classes.paymentMethodLogo} />
                                        </div>
                                        <div className={classes.paymentMethod}>
                                            <img src="/images/m-pesa.png" alt="vodacom" className={classes.paymentMethodLogo} />
                                        </div>
                                    </div>

                                    <div className={classes.safeText}>🔒 Seguro e Instantâneo</div>
                                </div>

                                <div className={classes.appCard}>
                                    <div className={classes.appLeft}>

                                        <div className={classes.cardTitle}>
                                            <span className={classes.iconDot} /> App Android
                                        </div>

                                        <button className={classes.downloadBtn}>Download Now</button>

                                        <div className={classes.ratingRow}>
                                            <div className={classes.ratingValue}>4.8</div>
                                            <div className={classes.stars}>
                                                <FaStar className={classes.star} />
                                                <FaStar className={classes.star} />
                                                <FaStar className={classes.star} />
                                                <FaStar className={classes.star} />
                                                <FaStar className={classes.star} />
                                            </div>
                                        </div>
                                    </div>

                                    <img src="/images/android2.png" alt="android" className={classes.phoneMock} />
                                </div>
                            </section>
                        </section>



                        {/* FOOT CHIPS */}
                        <section className={classes.hero_container}>
                            <footer className={classes.footerChips}>
                                <div className={classes.footChip}>💬 Suporte 24/7</div>
                                <div className={classes.footChip}>⛔ Cancela Quando Quiseres</div>
                            </footer>
                        </section>

                    </section>

                </section>
            </motion.div>
        </main>
    );
};

export default SubscriptionPage2;